import {
  GET_RAZORPAY_KEY_ID,
  RAZORPAY_CALLBACK_URL,
  optionsThemeColor,
} from "../../constants/config";

async function RazorpayPaymentHandler(punchPaymentResponse, order) {
  const paymentOptions = {
    key: GET_RAZORPAY_KEY_ID(order.vertical_id),
    amount: punchPaymentResponse.amount * 100,
    order_id: punchPaymentResponse.payment_details.provider_details.gateway_order_id,
    callback_url: RAZORPAY_CALLBACK_URL,
    theme: optionsThemeColor,
    redirect: true,
  };

  const pay = new window.Razorpay(paymentOptions);
  pay.open();
}

export { RazorpayPaymentHandler };
